<template>
  <div class="sifa-cont-right">
    <div class="personbox" v-if="showBlock">
      <h2>发票管理-开具发票</h2>
      <div class="sub-page">仅展示90个自然日的订单</div>
      <div>
        <el-table :data="winLotList" style="width: 100%" :cell-style='styleCenter' :header-cell-style='styleCenter'>
          <el-table-column width="55" align="center">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checked" @change="checkedChange(scope.row.checked,scope.row)"></el-checkbox>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="orderNo" label="订单号" :show-overflow-tooltip="true"></el-table-column> -->
          <el-table-column prop="lotName" label="标的名称" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="费用类型">
            <template slot-scope="scope">
              <div v-if="scope">软件使用费</div>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="缴纳时间" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="platformCost" label="订单金额（元）" :show-overflow-tooltip="true"></el-table-column>
        </el-table>
      </div>
      <div class="bottom-page-div">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page.currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
        </el-pagination>
      </div>
      <div class="allCheck-box">
        <div class="inallCheck">
          <div class="allCheck">
            <el-checkbox v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          </div>
          <div style="display: flex;align-items: center;">
            <div style="font-size: 14px;margin-right: 20px;">已选择 <span style="font-size: 28px;color: #D9001B;">{{multipleSelection.length}}个</span> 订单</div>
            <div style="font-size: 14px;margin-right: 20px;">开票金额 <span style="font-size: 28px;color: #D9001B;">￥{{money}}</span> </div>
            <div style="margin-right: 20px;"><el-button @click="openDialog" type="primary">开具发票</el-button></div>
          </div>
        </div>
      </div>
      <el-dialog title="开具发票" :visible.sync="platformDialog">
        <div style="padding-bottom:20px">
          <span style="font-size: 16px;color: black;font-weight: 600;">开票金额：</span>
          <span style="font-size: 28px;color: #D9001B;">￥{{platformSumPrice}}</span>
        </div>
        <div class="tipTitle">
          <div class="tipText">* 请按照电子商务法及发票管理办法等相关规定填写发票信息，</div>
          <div class="tipText">若因填写无效信息或非法信息等造成包括但不限于无法成功开具发票等后果或法律责任，由您自行承担。</div>
          <el-form :model="addForm" :rules="rules" status-icon ref="ruleForm" label-width="120px" style="width:80% ;">
            <el-form-item label="发票类型：" prop="invoiceType">
              增值税普通发票
            </el-form-item>
            <el-form-item label="费用类型：" prop="invoiceTitlex">
              软件使用费
            </el-form-item>
            <el-form-item label="发票抬头：" prop="invoiceTitle">
              <el-input v-model="addForm.invoiceTitle" placeholder="请输入发票抬头"></el-input>
            </el-form-item>
            <el-form-item label="收件人手机号：" prop="recipientsPhone">
              <el-input v-model="addForm.recipientsPhone" placeholder="请输入收件人手机号"></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱：" prop="email">
              <el-input v-model="addForm.email" placeholder="请输入电子邮箱" type="email"></el-input>
            </el-form-item>
            <div style="margin-bottom: 22px;margin-left: 120px;font-size: 12px;color: rgb(217, 0, 27);">
              发票开具成功将发送至您指定的电子邮箱，请注意查收
            </div>
            <el-form-item label="发票备注：" prop="invoiceNote">
              <el-input v-model="addForm.invoiceNote"></el-input>
            </el-form-item>
            <div style="text-align: center;">
              <el-button type="primary" @click="submitForm('ruleForm')" style="min-width: 120px;">提 交</el-button>
            </div>
          </el-form>
        </div>
      </el-dialog>
    </div>
    <div class="personbox" v-else>
      <h2>发票管理-开具发票</h2>
      <div class="sub-page"></div>
      <div style="padding:0 30px;">
        <div style="display: flex;align-items: center;padding-bottom: 20px;">
          <!-- <img src="../../../assets/u15.png" alt="" style="width: 30px;margin-right: 10px;"> -->
          <div style="font-weight: 700;font-size: 20px;">发票申请成功！</div>
        </div>
        <div style="font-weight: 700;font-size: 16px;color: #F59A23;">发票申请已于{{formatDateTime(new Date())}}提交，请及时留意邮箱、查看电子发票！</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getCmsPlatformPage } from '@/api/biz/auction/winLot'
import { cmsSave } from '@/api/biz/auction/invoiceInfo'
import { isvalidatemobile } from "@/util/validate";
export default {
  name: 'orderInvoiceView',
  data() {
    const validatePhone = (rule, value, callback) => {
      if (isvalidatemobile(value)[0]) {
        callback(new Error(isvalidatemobile(value)[1]));
      } else {
        callback();
      }
    };
    return {
      styleCenter: { 'text-align': 'center' },
      winLotList: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      multipleSelection: [],
      platformDialog: false,
      platformSumPrice: 0,
      addForm: {
        invoiceType: 1,
        invoiceTitlex: '软件使用费',
        invoiceTitle: '',
        recipientsPhone: '',
        email: '',
        invoiceNote: '',
        money: '',
        winLotVOList: ''
      },
      invoiceType: 1,
      rules: {
        InvoiceType: [{ required: true, message: '请输入发票类型', trigger: 'blur' }],
        invoiceTitle: [{ required: true, message: '请输入费用类型', trigger: 'blur' }],
        expenseType: [{ required: true, message: '请输入发票抬头', trigger: 'blur' }],
        recipientsPhone: [{ required: true, message: '请输入收件人手机号', trigger: 'blur', validator: validatePhone }],
        email: [{ required: true, message: '请输入电子邮箱', trigger: 'blur' },
        { type: 'email', message: '邮箱格式不正确，请重新输入', trigger: 'blur' }],
      },
      checkAll: false,
      showBlock: true,
      money: '0'
    }
  },
  computed: { ...mapGetters(["userInfo"]) },
  created() {
    this.queryData(this.page);
  },
  methods: {
    formatDateTime(dateTimeStr) {
      const date = new Date(dateTimeStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}年${month}月${day}日 ${hours}:${minutes}:${seconds}`;
    },
    handleCheckAllChange(val) {
      this.checkAll = val;
      this.winLotList.forEach(tableData => {
        tableData.checked = val;
        if (val && !this.multipleSelection.includes(tableData)) {
          this.multipleSelection.push(tableData);
        } else if (!val) {
          const index = this.multipleSelection.findIndex(selection => selection === tableData);
          if (index !== -1) {
            this.multipleSelection.splice(index, 1);
          }
        }
      });
      // 更新完this.multipleSelection后再计算总价
      this.calculateTotalCost();
    },
    areAllItemsChecked() {
      return this.winLotList.every(tableData => tableData.checked);
    },
    checkedChange(checked, row) {
      const index = this.multipleSelection.findIndex(item => item === row);
      if (checked && index === -1) {
        this.multipleSelection.push(row);
      } else if (!checked && index !== -1) {
        this.multipleSelection.splice(index, 1);
      }
      if (row && this.areAllItemsChecked()) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
      // 更新完this.multipleSelection后再计算总价
      this.calculateTotalCost();
    },
    calculateTotalCost() {
      // 初始化总价
      this.money = 0;
      // 遍历所有选中的项，累加价格
      this.multipleSelection.forEach(item => {
        this.money += Number(item.platformCost);
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addForm.money = this.platformSumPrice;
          this.addForm.winLotVOList = this.multipleSelection;
          cmsSave(this.addForm).then(res => {
            if (res.data.data) {
              this.platformDialog = false;
              this.$message({ type: 'success', message: '操作成功,请前往开票历史查看!' })
              this.showBlock = false
            } else {
              this.$message({ type: 'error', message: '开票失败,请刷新后再试!' })
            }
            this.queryData(this.page);
          })
        } else {
          return this.$message({ type: 'warning', message: '请完成表单填写' })
        }
      });
    },
    openDialog() {
      if (this.multipleSelection.length > 0) {
        this.platformSumPrice = 0;
        this.multipleSelection.forEach(ele => {
          this.platformSumPrice += parseFloat(ele.platformCost);
        })
        this.platformDialog = true;
      } else {
        this.$message({ type: 'warning', message: '请至少选择一条数据' })
      }
    },
    queryData(page) {
      getCmsPlatformPage(page.currentPage, page.pageSize, { platformType: 2 }).then(res => {
        const data = res.data.data;
        if (data.records) {
          data.records.forEach(item => {
            item.checked = false;
          });
        }
        this.winLotList = data.records;
        this.page.total = data.total;
      })
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.queryData(this.page);
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.queryData(this.page);
    },
  },
}
</script>

<style scoped>
::v-deep .el-dialog__header {
  background-color: rgb(59, 133, 244);
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
::v-deep .el-dialog__title {
  color: #fff;
  font-size: 28px;
}
::v-deep .el-table {
  padding: 0 15px;
  margin-bottom: 10px;
}
::v-deep .el-table th.el-table__cell {
  background-color: rgb(236, 245, 255);
}
::v-deep .el-table thead {
  font-size: 16px;
  color: rgb(59, 133, 244);
}
.personbox {
  margin: 0 0 40px;
  background-color: #fff;
  display: block;
  min-height: 380px;
}
.personbox h2 {
  height: 30px;
  line-height: 30px;
  background: #e9e9e9;
  color: #424242;
  padding-left: 20px;
  font-size: 14px;
  font-weight: 400;
}
.sub-page {
  margin-left: 15px;
  font-size: 16px;
  color: rgb(0, 0, 0);
  padding: 2% 0;
}
.bottom-page-div {
  text-align: right;
  margin-right: 50px;
  height: 60px;
  margin-top: 20px;
}
.allCheck-box {
  padding: 20px 0;
  background-color: rgb(238, 242, 245);
}
.inallCheck {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  padding: 20px 0;
}
.allCheck {
  margin-left: 35px;
}
.tipTitle {
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 50%;
  transform: translateX(-50%);
}
.tipText {
  font-size: 14px;
  color: rgb(217, 0, 27);
  line-height: 30px;
}
</style>